import React from "react";

import Entities from "../../components/Entities";

function Tasks() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "tasks",
        fields: [
          { name: "Name", propertyName: "name", search: true },
          {
            name: "Start Date",
            propertyName: "startDate",
            format: (v) => v ? new Date(v).toISOString().slice(0, 10) : "",
          },
          {
            name: "End Date",
            propertyName: "endDate",
            format: (v) => v ? new Date(v).toISOString().slice(0, 10) : "",
          },
        ],
      }}
    />
  );
}

export default Tasks;
